"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendViaBeaconV2 = exports.ravenLog = exports.isObject = exports.isLocalStorageSupported = exports.isBeaconSupported = exports.isArray = exports.getJumboUrl = exports.formatJumboEvents = exports.convertToArray = exports.addMultipleListners = exports.JUMBO_URL = void 0;
exports.sendViaFetchV2 = sendViaFetchV2;

var _urlParse = _interopRequireDefault(require("url-parse"));

var _fetch = _interopRequireDefault(require("./fetch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var JUMBO_URL = "https://jumbo.zomato.com/event";
exports.JUMBO_URL = JUMBO_URL;

var addMultipleListners = function addMultipleListners(element, events, fn) {
  events.forEach(function (e) {
    return element.addEventListener(e, fn, false);
  });
};

exports.addMultipleListners = addMultipleListners;

var isBeaconSupported = function isBeaconSupported() {
  return !!(window.navigator && typeof window.navigator.sendBeacon == 'function');
};

exports.isBeaconSupported = isBeaconSupported;

var formatJumboEvents = function formatJumboEvents(raw_events) {
  var event_strings = raw_events.map(function (event) {
    return {
      header: event.header,
      payload: event.payload
    };
  });
  return event_strings;
};

exports.formatJumboEvents = formatJumboEvents;

var getJumboUrl = function getJumboUrl() {
  var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : JUMBO_URL;
  var parsed_url = new _urlParse["default"](url, true);

  if (typeof userId != 'undefined' && userId != '') {
    var query_params = Object.assign({}, parsed_url.query, {
      user_id: userId
    });
    parsed_url.set('query', query_params);
  }

  return parsed_url.toString();
};

exports.getJumboUrl = getJumboUrl;

var sendViaBeaconV2 = function sendViaBeaconV2(data, userId) {
  var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : JUMBO_URL;
  var jumbo_url = getJumboUrl(userId, url);
  return isBeaconSupported() && navigator.sendBeacon(jumbo_url, JSON.stringify({
    app_payload: data
  }));
};

exports.sendViaBeaconV2 = sendViaBeaconV2;

var getHeadersForJumbo = function getHeadersForJumbo(params) {
  var headers = {};
  return headers;
};

function sendViaFetchV2(data, userId) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var url = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : JUMBO_URL;
  var jumbo_url = getJumboUrl(userId, url);
  var request_params = {
    no_zpwa: true,
    method: 'POST',
    body: JSON.stringify({
      app_payload: data
    }),
    extras: {
      credentials: 'include'
    },
    headers: getHeadersForJumbo(params)
  };
  return (0, _fetch["default"])(jumbo_url, request_params).then(function (response) {
    return response;
  });
}

var ravenLog = function ravenLog(msg) {
  if (!!window && !!window._Raven && !!window._Raven.captureException) {
    window._Raven.captureException(new Error(msg + ' ' + e.message));
  }
};

exports.ravenLog = ravenLog;

var isArray = function isArray(arg) {
  return Array.isArray(arg);
};

exports.isArray = isArray;

var isObject = function isObject(arg) {
  return arg === Object(arg);
};

exports.isObject = isObject;

var isLocalStorageSupported = function isLocalStorageSupported() {
  return !!window.localStorage;
};

exports.isLocalStorageSupported = isLocalStorageSupported;

var convertToArray = function convertToArray(events) {
  var events_array = [];

  if (isArray(events)) {
    events_array = events;
  } else if (isObject(events) || typeof events === 'string') {
    events_array = [events];
  }

  return events_array;
};

exports.convertToArray = convertToArray;